export const environment = {
  production: false,
  baseUrl: "https://tracker-dev.azure.chevron.com",
  apiUrl: "https://tracker-dev.azure.chevron.com/api",
  apiScope: "https://etra-test.azure.chevron.com/user_impersonation",
  graphScopes: [
    "User.Read",
    "User.Read.All",
    "Directory.Read.All"
  ]
};
